module.exports = __webpack_public_path__ + "static/media/board_Julian_Mair.ae707d2e.jpg";